export const COPILOT_WINDOW_MODES = {
  EMBEDDED: 'embedded',
  FLOATING: 'floating',
  FULL: 'full'
};

export const CHAT_CONTEXT_TYPES = {
  MEETING: 0,
  CALL: 0,
  DEAL: 1,
  GLOBAL: 2,
  COMPANY: 3,
  SCHEDULED: 4
};

export const CHAT_CONTEXT_TYPE_NAMES = {
  MEETING: 'meeting',
  CALL: 'call',
  DEAL: 'deal',
  GLOBAL: 'global',
  COMPANY: 'company'
};

export const MESSAGE_AUTHOR_TYPES = {
  COPILOT: 0,
  USER: 1,
  SYSTEM: 2
};

export const MESSAGE_STATUS_OPTIONS = {
  THINKING: 'thinking',
  IN_PROGRESS: 'in_progress',
  FINISHED_SUCCESSFULLY: 'finished_successfully'
};

export const COPILOT_ERROR_MESSAGE = {
  author: MESSAGE_AUTHOR_TYPES.SYSTEM,
  message:
    'An unexpected error occurred. Please try submitting your message again.'
};

export const ENGAGEMENT_TYPES = {
  GLOBAL_MEETING: 'meeting',
  DEAL_MEETING: 'meeting_engagement',
  EMAIL: 'email_engagement'
};

export const SUGGESTED_PROMPTS_TYPES = {
  AI: '0',
  DEFAULT: '1'
};

export const MEETING_SUGGESTED_PROMPTS = [
  {
    text: 'Can you summarize the key discussion points from this conversation?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'What action items were discussed during this conversation?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'What were the main topics covered in this conversation?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Can you list the pain points the client is currently facing?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  }
];

export const COMPANY_SUGGESTED_PROMPTS = [
  {
    text: `Provide a summary of our organization's relationship history with this company`,
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Highlight current challenges or potential risks in this customer account',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Outline a timeline of key interactions and milestones with this account',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: `Describe this company's current sentiment and engagement level`,
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  }
];

export const DEAL_SUGGESTED_PROMPTS = [
  {
    text: 'Summarize the deal: focus on objectives, challenges, timeline, and next steps.',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Outline a timeline of significant events related to this deal.',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Identify the primary concerns of the decision-makers involved in this deal.',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Describe the customer’s current sentiment towards this deal.',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  }
];

export const GLOBAL_SUGGESTED_PROMPTS = [
  {
    text: 'What were the main discussion points from my meetings this past week?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: `Generate an email update for my team based on this past week’s meetings.`,
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'Provide a detailed overview of our recent deals, summarizing patterns across prospects.',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  },
  {
    text: 'What follow-ups do I owe based on recent meetings?',
    type: SUGGESTED_PROMPTS_TYPES.DEFAULT
  }
];

export const CHAT_CONTEXT_ICON_FILTER_CLASSES = {
  [CHAT_CONTEXT_TYPES.MEETING]:
    '[&>path]:!fill-tulip-tree-600 [&>path]:!stroke-none',
  [CHAT_CONTEXT_TYPES.CALL]:
    '[&>path]:!fill-tulip-tree-600 [&>path]:!stroke-none',
  [CHAT_CONTEXT_TYPES.DEAL]:
    '[&>path]:!fill-mountain-meadow-600 [&>path]:!stroke-none',
  [CHAT_CONTEXT_TYPES.COMPANY]:
    '[&>path]:!fill-mountain-meadow-600 [&>path]:!stroke-none',
  [CHAT_CONTEXT_TYPES.GLOBAL]: 'filter-avomaRed'
};

export const AI_STATE_TRANSCRIPT_SUCCESS_STATUSES = [
  'process_transcription_complete_start',
  'transcription_email_ready',
  'processing_complete'
];

/** Category value for "Recently used" in saved prompts UI */
export const RECENTLY_USED = 'RECENTLY_USED';

/** Category value for "All prompts" in saved prompts UI */
export const ALL_PROMPTS = 'ALL';

/** Category value for "Scheduled for you" in saved prompts UI */
export const SCHEDULED_FOR_YOU = 'SCHEDULED_FOR_YOU';

export const SCHEDULED_PROMPT_STATE_TYPES = {
  ARCHIVED: 0,
  PAUSED: 1,
  ACTIVE: 2
};

export const SCHEDULED_PROMPT_FREQUENCIES = [
  { label: 'Weekdays (Mon - Fri)', value: 'weekdays' },
  {
    label: 'Weekly',
    value: 'weekly'
  },
  {
    label: 'Monthly',
    value: 'monthly'
  }
];

export const SCHEDULED_PROMPT_DAYS_OF_WEEK = [
  { label: 'Monday', value: 'MO' },
  { label: 'Tuesday', value: 'TU' },
  { label: 'Wednesday', value: 'WE' },
  { label: 'Thursday', value: 'TH' },
  { label: 'Friday', value: 'FR' },
  { label: 'Saturday', value: 'SA' },
  { label: 'Sunday', value: 'SU' }
];

export const SCHEDULED_PROMPT_MONTHLY_DAYS = [
  { label: '1st', value: '1' },
  { label: '2nd', value: '2' },
  { label: '3rd', value: '3' },
  { label: '4th', value: '4' },
  { label: '5th', value: '5' },
  { label: '6th', value: '6' },
  { label: '7th', value: '7' },
  { label: '8th', value: '8' },
  { label: '9th', value: '9' },
  { label: '10th', value: '10' },
  { label: '11th', value: '11' },
  { label: '12th', value: '12' },
  { label: '13th', value: '13' },
  { label: '14th', value: '14' },
  { label: '15th', value: '15' },
  { label: '16th', value: '16' },
  { label: '17th', value: '17' },
  { label: '18th', value: '18' },
  { label: '19th', value: '19' },
  { label: '20th', value: '20' },
  { label: '21st', value: '21' },
  { label: '22nd', value: '22' },
  { label: '23rd', value: '23' },
  { label: '24th', value: '24' },
  { label: '25th', value: '25' },
  { label: '26th', value: '26' },
  { label: '27th', value: '27' },
  { label: '28th', value: '28' },
  { label: '29th', value: '29' },
  { label: '30th', value: '30' },
  { label: '31st', value: '31' }
];

export const SCHEDULED_PROMPT_TIMES = [
  { label: '7:00 AM', value: '07:00' },
  { label: '8:00 AM', value: '08:00' },
  { label: '9:00 AM', value: '09:00' },
  { label: '10:00 AM', value: '10:00' },
  { label: '11:00 AM', value: '11:00' },
  { label: '12:00 PM', value: '12:00' },
  { label: '1:00 PM', value: '13:00' },
  { label: '2:00 PM', value: '14:00' },
  { label: '3:00 PM', value: '15:00' },
  { label: '4:00 PM', value: '16:00' },
  { label: '5:00 PM', value: '17:00' },
  { label: '6:00 PM', value: '18:00' },
  { label: '7:00 PM', value: '19:00' }
];

export const SCHEDULED_PROMPT_REFINE_OPTIONS = {
  STRUCTURED: {
    label: 'Make it structured',
    value: 0
  },
  INTENT_AND_OUTPUT: {
    label: 'Add intent and output',
    value: 1
  },
  DEEPER_INSIGHTS: {
    label: 'Expand for deeper insights',
    value: 2
  }
};
